export class IdentityProvidersNames {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providers",
            "baseName": "providers",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "supportsSsoOnly",
            "baseName": "supportsSsoOnly",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "orgLoginUrl",
            "baseName": "orgLoginUrl",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IdentityProvidersNames.attributeTypeMap;
    }
    constructor() {
    }
}
